import type { ExplorerTreeNode } from './types.js';

function nodeMatches(node: ExplorerTreeNode, lowerQuery: string): boolean {
	if (node.name.toLowerCase().includes(lowerQuery)) return true;
	for (const label of node.labels) {
		if (label.toLowerCase().includes(lowerQuery)) return true;
	}
	return false;
}

export function filterTree(root: ExplorerTreeNode, query: string | undefined): ExplorerTreeNode | undefined {
	if (!query) return root;
	const lowerQuery = query.toLowerCase();
	return filterNode(root, lowerQuery);
}

function filterNode(node: ExplorerTreeNode, lowerQuery: string): ExplorerTreeNode | undefined {
	const selfMatches = nodeMatches(node, lowerQuery);

	if (!node.children || node.children.length === 0) {
		return selfMatches ? node : undefined;
	}

	// If this node matches, keep the entire subtree
	if (selfMatches) return node;

	// Otherwise, keep only children (recursively) that match
	const filteredChildren: ExplorerTreeNode[] = [];
	for (const child of node.children) {
		const filtered = filterNode(child, lowerQuery);
		if (filtered) filteredChildren.push(filtered);
	}

	if (filteredChildren.length === 0) return undefined;

	return {
		...node,
		children: filteredChildren,
	};
}
